import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PanelSectionHeader from 'components/fulcrum/panelSectionHeader/PanelSectionHeader'
import PanelSection from 'components/fulcrum/panelSection/PanelSection'
import Collapse from 'components/fulcrum/collapse/Collapse'
import CSSModules from 'helpers/CSSModulesUtil'
import { Card } from 'react-toolbox/lib/card'

import ScheduleSpec from 'containers/Project/ScheduleSpec/index'
import styles from './styles.scss'
import ModuleHeaderContainer from 'components/project/ModuleHeaderContainer/index'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { nest} from 'recompose'
import {
    FILTER_ALL
} from 'containers/Project/Specifications/constants'

import {
    scheduleSelector
} from './selectors'

const mapStateToProps = state => {
    return {
        schedule: scheduleSelector(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

class ScheduleSection extends Component {
    static propTypes = {

    }
    constructor(props) {
        super(props)
        this.state = {
            collapse: false
        }
    }
    
    toggleCollapse(){
        this.setState({
            ...this.state,
            collapse: !this.state.collapse
        })
    }
    render() {
        const {
            schedule
        } = this.props
        return(
            <PanelSection>
                <PanelSectionHeader label='Schedule Section' />
                <Card>
                    <Collapse collapse={this.state.collapse}>
                    <ScheduleSpec
                        moduleData={ schedule }
                        segment={'Notebook'}
                        isModifiedPage={ false }
                        curFilter={ FILTER_ALL }
                        ModuleHeader={nest(ModuleHeaderContainer,
                            () => <span>Schedule</span>,
                        )}
                    />
                    </Collapse>
                </Card>
            </PanelSection>
        )
    }
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
    withConnect,
    withStyles
)

export default enhance(ScheduleSection)